import { html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import { SlotController } from "@/common/controllers/slot";
import EkoElement from "@/utilities/element";
import style from "./field.css?inline";

@customElement("eko-field")
export class Field extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  private defaultSlot = new SlotController(this);

  private handleLabelClick = (event: Event) => {
    const target = event.target as HTMLElement;
    if (target.tagName === "EKO-LABEL") {
      const checkbox = this.querySelector("eko-checkbox");
      if (checkbox) {
        checkbox.checked = !checkbox.checked;
      }
      const toggle = this.querySelector("eko-toggle");
      if (toggle) {
        toggle.checked = !toggle.checked;
      }
    }
  };

  render() {
    return this.defaultSlot.tagName === "eko-checkbox" || this.defaultSlot.tagName === "eko-toggle"
      ? this.renderChoiceField()
      : this.renderField();
  }

  renderChoiceField() {
    return html`<div class="eko-field__choice" part="choice">
      <slot id=${this.id}></slot>
      <slot name="label" @click=${this.handleLabelClick}></slot>
      <div class="eko-field__choice-hint" part="choice-hint">
        <slot name="hint"></slot>
      </div>
    </div>`;
  }

  renderField() {
    return html`<div class="eko-field" gap=${this.gapSize} part="field">
      <slot name="label"></slot>
      <slot></slot>
      <slot name="hint"></slot>
    </div>`;
  }

  get gapSize() {
    return this.defaultSlot.tagName === "eko-radio-group" ? "lg" : "md";
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-field": Field;
  }
}

export default Field;
